module.exports = __webpack_public_path__ + "r-v3/img/good.2ec8b735.svg";